export default __webpack_public_path__ + "bg1240acd.png";